import { render, staticRenderFns } from "./EditPatient.vue?vue&type=template&id=51fc0bac&scoped=true"
import script from "./EditPatient.vue?vue&type=script&lang=js"
export * from "./EditPatient.vue?vue&type=script&lang=js"
import style0 from "./EditPatient.vue?vue&type=style&index=0&id=51fc0bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc0bac",
  null
  
)

export default component.exports